// ARQUIVO GERADO AUTOMATICAMENTE — NÃO EDITE MANUALMENTE.
// Regenerado por `npm run generate`. Quaisquer alterações serão sobrescritas.
// Para adicionar ou remover uma API, adicione/remova o contrato .yml correspondente
// em `openapi/contracts/` e execute `npm run generate` novamente.

import { NgModule } from '@angular/core';
import { ApiModule as ActiveIndicatorApiModule } from './alert-service/active-indicator/api.module';
import { ApiModule as AlertApiModule } from './alert-service/alert/api.module';
import { ApiModule as EmailApiModule } from './alert-service/email/api.module';
import { ApiModule as IndicatorAlertApiModule } from './alert-service/indicator-alert/api.module';
import { ApiModule as RegistrationDataApiModule } from './alert-service/registration-data/api.module';
import { ApiModule as BulkLoadFileApiModule } from './bulk-load-service/bulk-load-file/api.module';
import { ApiModule as ClientPlanApiModule } from './configuration-service/client-plan/api.module';
import { ApiModule as IndicatorApiModule } from './configuration-service/indicator/api.module';
import { ApiModule as LegacyApiModule } from './configuration-service/legacy/api.module';
import { ApiModule as NotificationApiModule } from './configuration-service/notification/api.module';
import { ApiModule as PlanApiModule } from './configuration-service/plan/api.module';
import { ApiModule as PlanIndicatorApiModule } from './configuration-service/plan-indicator/api.module';
import { ApiModule as ProfileApiModule } from './configuration-service/profile/api.module';
import { ApiModule as UserApiModule } from './configuration-service/user/api.module';
import { ApiModule as DataIngestionApiModule } from './data-ingestion/data-ingestion/api.module';
import { ApiModule as RegistryApiModule } from './wallet-service/registry/api.module';
import { ApiModule as TrackingRegistryApiModule } from './wallet-service/tracking-registry/api.module';
import { ApiModule as WalletApiModule } from './wallet-service/wallet/api.module';

@NgModule({
  imports: [
    ActiveIndicatorApiModule,
    AlertApiModule,
    EmailApiModule,
    IndicatorAlertApiModule,
    RegistrationDataApiModule,
    BulkLoadFileApiModule,
    ClientPlanApiModule,
    IndicatorApiModule,
    LegacyApiModule,
    NotificationApiModule,
    PlanApiModule,
    PlanIndicatorApiModule,
    ProfileApiModule,
    UserApiModule,
    DataIngestionApiModule,
    RegistryApiModule,
    TrackingRegistryApiModule,
    WalletApiModule,
  ],
  exports: [
    ActiveIndicatorApiModule,
    AlertApiModule,
    EmailApiModule,
    IndicatorAlertApiModule,
    RegistrationDataApiModule,
    BulkLoadFileApiModule,
    ClientPlanApiModule,
    IndicatorApiModule,
    LegacyApiModule,
    NotificationApiModule,
    PlanApiModule,
    PlanIndicatorApiModule,
    ProfileApiModule,
    UserApiModule,
    DataIngestionApiModule,
    RegistryApiModule,
    TrackingRegistryApiModule,
    WalletApiModule,
  ],
})
export class GeneratedApiModule {}
